// agreement cookies

function shopOpenConsentManager() {
	$('#agreementPrivacy').show();
	$('#agreementPrivacy').addClass('isFixed');
	$('#cookieStart').hide();
	$('#agreementPrivacyDetails').show();
	bodyScrollLock();
}

function shopCloseConsentManagerDetails(){
	$('#agreementPrivacyDetails').hide();
	$('#agreementPrivacy').removeClass('isFixed');
	$('#cookieStart').show();
	// bodyScrollUnlock();
}

$(function(){
	$('input.ws_useragreement4alls').on('click',function(e){
		// console.log(e);
		e.preventDefault();
		var consentItemClass = 'ws_useragreement_optin_'; // checks item checkboxes
		$("input[type=checkbox]input[class^='" + consentItemClass + "'],input[type=checkbox]input[class*='" + consentItemClass + "']").each(function () {
			$(this).prop('checked', true);
		});
		var consentGroupClass = 'ws_useragreementcgc_'; // checks group checkboxes
		$("input[type=checkbox]input[class^='" + consentGroupClass + "'],input[type=checkbox]input[class*='" + consentGroupClass + "']").each(function () {
			$(this).prop('checked', true);
		});
		ws_agreementcookies_set();
		location.reload();
	});
});


